import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgPremium = (props) => (
  <SvgIcon {...props} title="Premium">
    <svg
      viewBox="0 0 49 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.653.033c-.572.11-1.198.429-1.582.807-.143.142-1.893 2.658-4.497 6.47-2.345 3.43-4.277 6.244-4.295 6.253-.018.01-1.975-1.465-4.35-3.276-4.615-3.52-4.571-3.489-5.124-3.63-1.94-.496-3.8.928-3.794 2.901 0 .284.426 3.62 1.267 9.936 1.147 8.622 1.258 9.515 1.19 9.57-.991.795-1.611 1.587-2.013 2.572-1.34 3.287.39 7.044 3.728 8.099.9.284-.573.265 19.99.265 20.562 0 19.089.02 19.989-.265 3.339-1.055 5.068-4.812 3.727-8.099-.401-.985-1.021-1.777-2.012-2.572-.069-.055.042-.948 1.19-9.57.84-6.316 1.266-9.652 1.267-9.936.006-1.973-1.855-3.397-3.794-2.901-.553.141-.51.11-5.124 3.63-2.375 1.811-4.333 3.285-4.35 3.276-.018-.009-1.95-2.823-4.295-6.254C26.405.919 26.283.753 25.761.437c-.545-.33-1.52-.517-2.108-.404Zm4.766 9.282c3.223 4.725 4.296 6.264 4.53 6.498.953.95 2.566 1.127 3.706.408.17-.108 2.17-1.614 4.443-3.348 2.274-1.733 4.143-3.143 4.154-3.132.015.016-2.268 17.374-2.37 18.012l-.025.165H5.488l-.026-.165c-.102-.638-2.385-17.996-2.37-18.012.012-.01 1.88 1.399 4.155 3.133 2.273 1.733 4.273 3.24 4.443 3.347 1.14.72 2.753.542 3.705-.408.235-.234 1.308-1.773 4.53-6.498 2.323-3.406 4.235-6.192 4.247-6.192.013 0 1.924 2.786 4.247 6.192Zm14.46 21.717c3.116.66 3.193 5.07.102 5.853-.428.108-37.19.108-37.617 0-3.077-.78-3.017-5.178.08-5.85.463-.1 36.961-.103 37.434-.003Z"
        fill="#017163"
      />
    </svg>
  </SvgIcon>
);

export default SvgPremium;
